import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Store/actions";

import { BrowserCamera } from "../../common/components";
import NativeCamera from "../../common/components/NativeCamera";
import ImageArea from "../../common/components/NativeCamera/ImageArea";
import { logToSentry } from "../../config/Sentry";

const CameraSourceSwitch = ({ step, imgIndex, assetMode }) => {
    const dispatch = useDispatch();

    const [camOpen, setCamOpen] = useState(false);

    const { appSettings, assetDetails } = useSelector((state) => state);
    const { cameraSource } = appSettings;
    const { assetTypeID, exclusionReasonTypeId, photos, stepsCompleted } =
        assetDetails;

    const onCamClose = () => {
        setCamOpen(false);
    };

    // always default to native camera
    const nativeCamera = cameraSource !== "browser";

    /** On Save Photo */
    const onPhotoSuccess = (photo: any) => {
        const updPhotos = [...photos];
        if (updPhotos[imgIndex]) updPhotos[imgIndex] = photo;
        else updPhotos.push(photo);

        const updStepsCompleted = [...stepsCompleted];
        updStepsCompleted[step] = true;

        dispatch(
            actions.assetDetails.create.set({
                photos: updPhotos,
                stepsCompleted: updStepsCompleted,
                // increment to the next step
                activeStep: step + 1 > stepsCompleted.length ? step : step + 1,
            })
        );

        onCamClose();
    };

    const onCameraError = (error) => {
        console.error(error);
        const link = (
            <CameraLocationError message={t("errors.noDeviceCamera")} />
        );

        toast.error(link);
        logToSentry(`onCameraError:`, {
            error,
        });
        onCamClose();
    };

    const triggerCamera = () => {
        if (nativeCamera)
            document.getElementById(`camera-file-upload-${imgIndex}`).click();
        else setCamOpen(true);
    };

    return (
        <>
            <ImageArea
                imgIndex={imgIndex}
                assetMode={assetMode}
                imageSrc={photos[imgIndex] ? photos[imgIndex].image : false}
                triggerCamera={triggerCamera}
            />

            {nativeCamera ? (
                <NativeCamera
                    step={step}
                    imgIndex={imgIndex}
                    assetMode={assetMode}
                />
            ) : (
                <BrowserCamera
                    disableImageType={true}
                    assetTypeId={assetTypeID}
                    exclusionReasonTypeId={exclusionReasonTypeId}
                    isVisible={camOpen}
                    photos={photos}
                    onClose={onCamClose}
                    onSuccess={onPhotoSuccess}
                    onError={onCameraError}
                />
            )}
        </>
    );
};

export default CameraSourceSwitch;
